export enum RolePermissions {
    ViewManagement = 'ViewManagement',
    QueryContributor = 'QueryContributor',
    DataSetContributor = 'DataSetContributor',
    ReportViewContributor = 'ReportViewContributor',
    ResourceStringContibutor = 'ResourceStringContibutor',
    ProviderContributor = 'ProviderContributor',
    ReportsDelete = 'reports.delete',
    ReportsShare = 'reports.share',
    ReportsView = 'reports.view',
    ReportsExport = 'reports.export',
    ReportsCreate = 'reports.create',
    ReportsEdit = 'reports.edit',
}
